<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Road Map Report</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label>Session </label>
          <select class="form-control" v-model="filter.SemesterID">
            <option value="0">--Select Session--</option>
            <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Degree </label>
          <select class="form-control" v-model="filter.DegreeID" v-on:change="loadDepartment()">
            <option value="0">--Select Degree--</option>
            <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Departments </label>
          <select class="form-control" v-model="filter.DepartmentID" v-on:change="loadPrograms()">
            <option value="0">--Select Degree--</option>
            <option v-for="item in departments" v-bind:value="item.DepartmentID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Program</label>
          <select class="form-control" v-model="filter.ProgramID">
            <option value="0">--Select Program--</option>
            <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
          </select>
        </div>
        <div class="col-md-12">
          <div class="form-group float-right">
            <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Print</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        departments: [],
        programs: [], 
        semesters: [],
        degrees: [], 
        filter: { SemesterID: 0, ProgramID: 0,DepartmentID:0 , DegreeID:0},

      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },


    methods: {

      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/prospectStudentsPageLoad')
          .then(function (pl) {
            endReq();
            vm.semesters = pl.data["sem"];
            vm.degrees = pl.data["deg"]; 
            //vm.programs = pl.data["programs"]; 
            //vm.departments = pl.data["programs"]; 
          })
      },

      loadDepartment() {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/loadDepartments?semID=' + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID)
          .then(function (res) {
            vm.departments = res.data.lst;
            endReq();
          })
      },
      loadPrograms() {
        var vm = this; 

        startReq();
        axios.post('/api/AdmissionApi/loadProgramsProspect?semID=' + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID + "&depID=" + vm.filter.DepartmentID)
          .then(function (res) {
            vm.programs = res.data.lst;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      btnSearch() {

        startReq();

        var vm = this;

        axios.post('/api/DCApi/RoadMapFilter', {
          filter: vm.filter,
        })
          .then(function (res) {
            window.open("/DC/RoadMapReportPrint");
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },


    }
  })</script>
 



// WEBPACK FOOTER //
// src/components/DC/RoadMapReport.vue